<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Business User</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmUpdateWhb">
          <fieldset :disabled="isUpdating">
            <div class="field is-horizontal">
              <div class="control">
                <label class="checkbox">
                  <input v-model="isBusinessUser" type="checkbox" />
                  Is Business User
                </label>
              </div>
            </div>
          </fieldset>

          <fieldset :disabled="!isBusinessUser || isUpdating">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Expires At</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <FlatPickr v-model="expires" :config="expiresDateConfig" class="input" />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="updateError">
          {{ updateError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancelUpdateWhb" :disabled="isUpdating">
              Cancel
            </button>
            <button
              class="button is-primary"
              @click="confirmUpdateWhb"
              :class="{ 'is-loading': isUpdating }"
              :disabled="isUpdating"
            >
              Save
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import FlatPickr from 'vue-flatpickr-component'

import { UPDATE_WHB } from './userStore'

export default {
  name: 'UserUpdateWhbModal',

  components: { FlatPickr },

  props: {
    userStorePath: {
      type: String,
      required: true
    },

    whb: {
      type: Object
    }
  },

  data() {
    return {
      isBusinessUser: false,
      expires: null,
      isUpdating: false,
      updateError: undefined
    }
  },

  mounted() {
    if (!this.whb) {
      return
    }

    this.isBusinessUser = this.whb.isBusinessUser
    this.expires = this.whb.expires ?? new Date()
  },

  computed: {
    expiresDateConfig() {
      return {
        enableTime: false,
        dateFormat: 'Y-m-d',
        minDate: new Date(),
        locale: {
          firstDayOfWeek: 1
        }
      }
    }
  },

  methods: {
    cancelUpdateWhb() {
      this.$emit('cancelled')
    },

    async confirmUpdateWhb() {
      var expiresDay = dayjs(this.expires).format('YYYY-MM-DD')

      this.updateError = undefined
      this.isUpdating = true

      try {
        const updateWhbAction = `${this.userStorePath}/${UPDATE_WHB}`
        await this.$store.dispatch(updateWhbAction, {
          isBusinessUser: this.isBusinessUser,
          expiresDay
        })

        this.$emit('succeeded')
      } catch (error) {
        this.updateError = error || 'Something went wrong.'
      } finally {
        this.isUpdating = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
